// Central geographical constants for the app.
//
// NICE_ANCHOR is the frozen anchor point for the parser → backend import flow.
// See `.omo/plans/parser-import-flow.md` §1 (Frozen decisions) — the coord is
// hard-coded and MUST NOT be overridden per-user for the current MVP.
export const NICE_ANCHOR = Object.freeze({
  lat: 43.7102,
  lng: 7.2620,
  name: 'Nice, France',
});

// Radius presets used by the import ScopeStep slider snapping.
export const RADIUS_PRESETS_KM = Object.freeze([5, 10, 25, 50, 100, 200]);

// Haversine distance in km between two {lat,lng} points.
export const haversineKm = (a, b) => {
  if (!a || !b) return null;
  const R = 6371;
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};
